import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import {compareAttributes} from '../../utils';

function noop() {}

export default class AttributeSelectionWidget extends Component {
  static propTypes = {
    attribute: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    selected: PropTypes.string,
    variant: PropTypes.object,
  };

  handleChange = (attrPk, valuePk) => {
    this.props.handleChange(attrPk.toString(), valuePk.toString());
  };

  render() {
    const { attribute, selected, variants, selection } = this.props;
    return (
      <div className="variant-picker">
        <div className="variant-picker__label hide-xss">{attribute.name}</div>
        <div className="btn-group" data-toggle="buttons">
          {attribute.values.map((value, i) => {
            let matchedVariant = null;
            let selectionModified = {
              ...selection,
              [attribute.pk]: `${value.pk}`,
            };
            variants.forEach(variant => {
              if (compareAttributes(selectionModified, variant.attributes)) {
                matchedVariant = variant;
              }
            });
            const active = selected === value.pk.toString();
            const labelClass = classNames({
              'btn btn-secondary variant-picker__option': true,
              active: active,
              // Add asecond class because something else is consuming the 'active' class even when it shouldn't.
              // My guess is that it is something in Bootstrap.
              factive: active,
              'out-of-stock': matchedVariant && !matchedVariant.availability,
            });
            return (
              <label
                className={labelClass}
                key={i}
                onClick={matchedVariant && matchedVariant.availability ? () => this.handleChange(attribute.pk, value.pk) : noop}
              >
                <input defaultChecked={active} name={value.pk} type="radio" disabled={matchedVariant && !matchedVariant.availability} />
                {value.name}
              </label>
            );
          })}
        </div>
      </div>
    );
  }
}
